import { render, staticRenderFns } from "./MoreLikeThis.vue?vue&type=template&id=021463d7&"
import script from "./MoreLikeThis.vue?vue&type=script&lang=js&"
export * from "./MoreLikeThis.vue?vue&type=script&lang=js&"
import style0 from "./MoreLikeThis.vue?vue&type=style&index=0&id=021463d7&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VDivider,VIcon,VProgressCircular})
